import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Main from "../pages/subpages/Main";
import Curry from "../pages/subpages/Curry";
import Rainbow from "../pages/subpages/Rainbow";
// import { redirect } from "react-router-dom";

// const Auth = React.lazy(() => import("../pages/auth/Auth"));
// const ProtectedRouter = React.lazy(() => import("./Protected"));
const Footer = ({ ...props }) => {
  return (
    <>
      <footer>
        <p>
          Made with ❤️ by{" "}
          <a href="https://www.itsanand.tech/" target="_blank" rel="noopener noreferrer">
            Anand
          </a>{" "}
        </p>
      </footer>
    </>
  );
};
function AppRoutes(props) {
  console.log("App...");
  // const [user, setUser] = useState(false);

  return (
    // <React.Suspense fallback={null}>

    <Router>
      <Routes>
        {/* <Route path="/" element={<ProtectedRouter user={user} />} /> */}
        <Route path="/" element={<Main />} />
        <Route path="/rainbow" element={<Rainbow />} />
        <Route path="/curry" element={<Curry />} />
      </Routes>
      <Footer />
    </Router>
    // {/* </React.Suspense> */}
  );
}

export default AppRoutes;
